var _style, _g, _defs, _path, _path2, _path3, _path4, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRyeFlour({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA1917;}\n\t.st1{clip-path:url(#XMLID_2_);fill:#CE9F76;}\n\t.st2{fill:#FFEECC;}\n\t.st3{fill:#E4BC8C;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#D8B593;stroke-width:0.8154;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#D8B593;stroke-width:0.8154;stroke-miterlimit:10;stroke-dasharray:1.6936,1.6936;}\n\t.st7{fill:none;stroke:#D8B593;stroke-width:0.8154;stroke-miterlimit:10;stroke-dasharray:1.5602,1.5602;}\n\t.st8{fill:none;stroke:#D8B593;stroke-width:0.8154;stroke-miterlimit:10;stroke-dasharray:1.5943,1.5943;}\n\t.st9{fill:none;stroke:#D8B593;stroke-width:0.8154;stroke-miterlimit:10;stroke-dasharray:1.6028,1.6028;}\n\t.st10{fill:#B49577;}\n\t.st11{fill:#F9D1A9;}\n\t.st12{fill:#FBE5D5;}\n\t.st13{fill:#D8B593;}\n\t.st14{fill:#CE9F76;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000159444228809919061170000005245383006233608125_",
    d: "M71.25,82.44c0,0-3.92,7.14-3.85,26.58 s1.24,25.21,1.24,25.21s-2.48,2.43-3.3,6.23s1.03,7.44,7.84,6.68c6.81-0.76,8.81-1.67,8.81-1.67s7.36,3.72,21.88,3.8 s25.87-3.65,25.87-3.65s4.06,2.28,9.77,2.73s9.98-3.95,6.74-9.57c-3.23-5.62-3.23-5.62-3.23-5.62s2.61-27.04-0.07-39.04 s-2.68-12-2.68-12L71.25,82.44z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000159444228809919061170000005245383006233608125_",
    style: {
      overflow: "visible",
      fill: "#E4BC8C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000159444228809919061170000005245383006233608125_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.96,93.71l-24.07,4.72c-7.9,1.55-15.99,1.58-23.9,0.08L69.56,93.7c-1.14-0.22-1.97-1.31-1.97-2.58v-8.84 c0-1.45,1.06-2.62,2.37-2.62h72.58c1.31,0,2.37,1.17,2.37,2.62v8.85C144.91,92.4,144.09,93.48,142.96,93.71z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.21,78.26c0,0,10.56-13.82,22.12-19.06s22.91-4.4,30.41,1.22s13.07,17.16,13.07,17.16L73.21,78.26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.35,86.01l-24.07,4.72c-7.9,1.55-15.99,1.58-23.9,0.08L68.96,86c-1.14-0.22-1.97-1.31-1.97-2.58v-8.84 c0-1.45,1.06-2.62,2.37-2.62h72.58c1.31,0,2.37,1.17,2.37,2.62v8.85C144.31,84.7,143.49,85.79,142.35,86.01z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.12,98.35c0,0,8.93,1.48,12.56,2.49s7.6,1.32,11.44,1.09c3.84-0.23,13.74-0.31,15.77-0.62 c2.02-0.31,3.63-1.25,3.63-1.25s1.19,21.42,0.98,25.55c-0.21,4.13,0.56,11.68,0.56,11.68s-5.3,1.01-10.19,2.34 c-4.88,1.32-21.21,3.74-27.63,2.03c-6.42-1.71-6.42-1.71-6.42-1.71s-1.26-12.46-1.4-17.91s-0.7-13.09-0.14-15.42 C84.85,104.27,85.12,98.35,85.12,98.35z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.77,100.86c0.03-0.5,0.04-0.81,0.04-0.81s0.3,0.05,0.8,0.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.29,100.47c2.7,0.48,6.94,1.27,9.12,1.87c3.35,0.93,7.02,1.22,10.56,1.01s12.68-0.29,14.55-0.57 c0.68-0.1,1.31-0.28,1.83-0.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M126.13,101.99c0.46-0.2,0.73-0.36,0.73-0.36s0.02,0.29,0.04,0.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M126.99,103.99c0.28,5.36,0.93,18.22,0.77,21.21c-0.14,2.68,0.17,6.91,0.37,9.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M128.2,135.18c0.05,0.51,0.08,0.81,0.08,0.81s-0.29,0.06-0.8,0.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M125.92,136.46c-1.84,0.39-4.5,0.99-7.04,1.68c-4.51,1.22-19.57,3.45-25.49,1.87 c-2.13-0.57-3.49-0.93-4.37-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88.25,138.64c-0.78-0.21-0.78-0.21-0.78-0.21s-0.03-0.29-0.08-0.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M87.23,136.03c-0.35-3.65-0.96-10.54-1.05-14.13c-0.13-5.03-0.64-12.08-0.13-14.23 c0.34-1.41,0.56-4.22,0.68-6.01"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M96.67,119.76L93,119.7l0.09-14.5c1.12-0.06,3.86-0.39,6.09,0.31c5.05,1.63,3.7,8.92-0.73,10.53 c0.91,0.49,2.65,0.53,3.63,0.61l-0.39,3.4c-1.25,0.26-4.06-0.67-5.07-1.59L96.67,119.76z M96.63,108.19 c0.04,1.43,0.05,3.14,0.02,4.89C99.18,112.57,100.12,108.17,96.63,108.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.12,106.76c-1.98,3.5-3.84,9.43-4.89,13.18l-4.11-0.14c0.2-1.2,1.42-4.97,1.8-5.91 c-0.71-1.38-2.6-5.4-2.9-6.5l2.26-1.51c0.28,1.02,1.24,3.38,1.89,5.05c0.78-1.61,1.92-4.16,2.92-5.7L113.12,106.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M120.28,119.33l-6.6-0.14v-12.02l6.64-0.14l0.11,3.12c-2.15-0.02-3.04,0.02-3.08,0.02l0.05,1.42 c0.04,0,0.09-0.02,2.65-0.06v2.75c-1.81,0.02-2.51,0-2.6,0v2.26l2.9-0.47L120.28,119.33z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M108.36,136.59c-10.32,3.07-14.59,1.05-15.51-2.74c-0.92-3.78,0.71-7.56,12.17-10.97 c8.27-2.46,17.63-1.1,18.36,1.89C124.03,127.45,116.63,134.13,108.36,136.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M117.94,131.75c3.55-2.61,5.81-5.45,5.44-6.98c-0.39-1.58-3.19-2.71-6.97-3.05 C118.95,125.43,119.07,128.44,117.94,131.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M123.39,125.41c-2.74,3.18-8.99,7.35-15.67,9.34c-6.65,1.98-11.03,2.2-13.74,1.32 c1.98,2.21,6.34,2.91,14.37,0.52C116.03,134.31,122.95,128.39,123.39,125.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M107.83,130.45c-8.14,2.42-14.85,3.94-14.98,3.4c-0.13-0.54,6.36-2.94,14.5-5.37 c8.14-2.42,14.85-3.94,14.98-3.4C122.46,125.62,115.97,128.03,107.83,130.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M119.83,124.03c-1.9,0.28-3.81,0.57-5.71,0.9c-2.36,0.42-4.76,0.82-7.08,1.47c-2.29,0.57-4.55,1.25-6.78,2.05 c-1.06,0.38-2.1,0.81-3.16,1.22c-0.8,0.31-1.57,0.72-2.37,1.04c3.43-3.21,7.59-5.08,11.92-6.21c2.27-0.62,4.71-0.94,7.06-0.97 C115.73,123.49,117.84,123.51,119.83,124.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRyeFlour);
export default __webpack_public_path__ + "static/media/Rye_flour.78ede00b36169f11b52df10a8f06a6ec.svg";
export { ForwardRef as ReactComponent };